document.addEventListener("DOMContentLoaded", () => {
  let copyBlock = document.querySelector(".js-copy-block");
  const copyPopup = document.querySelector(".copy-popup");
  let timeout;

  if (copyBlock) {
    let copyItems = copyBlock.querySelectorAll(".js-copy-item");
    let copyBtn = copyBlock.querySelector(".js-copy-button");
    let copyText = "";

    copyItems.forEach((item) => {
      copyText += item.innerText.replaceAll("\n\n", "\n") + "\n\n";
    });

    copyBtn.addEventListener("click", () => {
      navigator.clipboard.writeText(copyText);
      copyPopup.classList.add("copy-popup--visible");
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        copyPopup.classList.remove("copy-popup--visible");
      }, 5000);
    });
  }
});
